import { render } from "./ProductSvgShape.vue?vue&type=template&id=487408e6"
import script from "./ProductSvgShape.vue?vue&type=script&lang=js"
export * from "./ProductSvgShape.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__